export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  api: 'https://api.iformacion.net'
};
